var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return !_vm.value.hasSheet
    ? _c("app-file-upload", {
        attrs: {
          "max-size": 50e6,
          disabled: _vm.processing,
          "allowed-extensions": _vm.extensions,
          label: _vm.$ct("excel-file"),
        },
        on: {
          input: function ($event) {
            return _vm.onFile($event)
          },
        },
      })
    : _c(
        "div",
        [
          _c("w-fa", { attrs: { icon: "file-excel" } }),
          _vm._v(" " + _vm._s(_vm.sheetTitle) + " "),
          _c(
            "w-button",
            {
              attrs: { flat: "" },
              on: {
                click: function ($event) {
                  return _vm.removeFile()
                },
              },
            },
            [_c("w-fa", { attrs: { icon: "times" } })],
            1
          ),
        ],
        1
      )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }